$(document).ready(function () {
  $(".purchase-date input").attr("type", "date");
  $("input[type='tel']").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
      // Allow: Ctrl+A, Command+A
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  });
  $(".name_field").bind("copy paste", function (e) {
    e.preventDefault();
  });
  $(".name_field").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13, 32]) !== -1 ||
      // Allow: Ctrl+A, Command+A
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (e.keyCode < 65 || e.keyCode > 90) {
      e.preventDefault();
    }
  });
   jQuery(".name_field").on('input', function() {
     var value = jQuery(this).val();
     var newValue = value.replace(/[^a-zA-Z\s]/g, '');
     if (value !== newValue) {
       jQuery(this).val(newValue);
     }
   });
  $(".number_field").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
      // Allow: Ctrl+A, Command+A
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
    // $("#attachment").on("change",function (e) {
    //   var filename = this.files[0]?.name || '';
    //   console.log(filename);
    //   $("#filevalue").html(filename+'<i class="remove-file fa fa-remove"></i>');
    // });
  	
    // $(document).on("click",".remove-file",function(){
  	 //  $('#attachment').val('');
  	 //  $("#filevalue").html("Upload Image");
    // });
  });


  var list = $('.testimonial-ul');
  var review = list.find('li');
  var totalreview = review.length;
  //console.log(totalgallery);
  review.hide();
  review.slice(0, 9).show();

  if (totalreview <= 9) {
        $('.btn_loadmore').css('display', 'none');
  }
  $('.btn_loadmore').on('click', function (e) {
        e.preventDefault();
        var list = $(this).parent().prev().closest('.testimonial-ul li:hidden');
        $(this).parent().prev(".testimonial-ul").find('li:hidden').show();
        var nowShowing = $(this).parent().prev(".testimonial-ul").find('li:visible').length;
        if (nowShowing >= totalreview) {
            $('.btn_loadmore').css('display', 'none');
        }
  });
});
let window_view_sizes = [993];
let window_views = {};

$(window).on('load resize orientationchange', function () {
    window_view_sizes.forEach(function (window_view_size) {
        if (this.innerWidth < window_view_size) {
            if (window_views[window_view_size] !== 'mobile') {
                window_views[window_view_size] = 'mobile';
                $(window).trigger('mobile_view_switch_' + window_view_size);
            }
        } else {
            if (window_views[window_view_size] !== 'desktop') {
                window_views[window_view_size] = 'desktop';
                $(window).trigger('desktop_view_switch_' + window_view_size);
            }
        }
    });
});

$(window).on('desktop_view_switch_993', function () {
    $.each($('.mobile-view > *'), function () {
        $('.desktop-view').append($(this));
    });
});

$(window).on('mobile_view_switch_993', function () {
    $.each($('.desktop-view > *'), function () {
        $('.mobile-view').append($(this));
    });
});

$(function(){
  $('.time-field,.popup-time-field').timepicker({
    timeFormat: 'HH:mm',
    interval: 15,
    minTime: '00:00',
    maxTime: '23:59',
    dropdown: true,
    scrollbar: true
  });

  var date = new Date();
  var minDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3);
  $( "#serv_datepicker,#datepicker" ).datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      dateFormat: "dd-mm-yy",
      minDate: minDate,
      beforeShowDay: $.datepicker.noWeekends
  });
  
  $(".view_price").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $tooltip = $(this).find(".tooltiptext");
    var $popup = $(this).closest('.getquote-form');

    // Toggle same tooltip
    if ($tooltip.hasClass("show")) {
        $tooltip.removeClass("show top bottom");
        return;
    }

    // Close others
    $(".tooltiptext").removeClass("show top bottom");

    // Get popup metrics
    var popupHeight = $popup.length ? $popup.height() : $(window).height();
    var popupScrollTop = $popup.length ? $popup.scrollTop() : $(window).scrollTop();
    var popupOffsetTop = $popup.length ? $popup.offset().top : 0;

    var elementOffsetTop = $(this).offset().top - popupOffsetTop;
    var elementHeight = $(this).outerHeight();
    var tooltipHeight = $tooltip.outerHeight();

    var spaceAbove = elementOffsetTop - popupScrollTop;
    var spaceBelow = popupHeight - (spaceAbove + elementHeight);

    // Position decision
    if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
        $tooltip.addClass("top");
    } else {
        $tooltip.addClass("bottom");
    }

    $tooltip.addClass("show");
});

  $(document).on("click", function (e) {
      if (!$(e.target).closest(".view_price").length) {
          $(".tooltiptext").removeClass("show");
      }
  });
});